import { t } from '../strings/i18n';
const ProductTypeToDisclosureText = {
    INSTALLMENT_LOAN_PAY_IN_FOUR: [
        'pn4PrimaryDisclosureText',
        'pn4SecondaryDisclosureText'
    ],
    INSTALLMENT_LOAN_MONTHLY: [
        'monthlyPrimaryDisclosureText',
        'monthlySecondaryDisclosureText'
    ]
};
const getDisclosureTextFromProductType = (productType) => {
    const [primaryDisclosureTextKey, secondaryDisclosureTextKey] = ProductTypeToDisclosureText[productType] || [
        'primaryDisclosureText',
        'secondaryDisclosureText'
    ];
    const primaryDisclosureText = t(`addPaymentMethod.${primaryDisclosureTextKey}`);
    const secondaryDisclosureText = t(`addPaymentMethod.${secondaryDisclosureTextKey}`);
    return [primaryDisclosureText, secondaryDisclosureText];
};
export default getDisclosureTextFromProductType;
